/* eslint-disable no-eval */
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Form, Components } from "@formio/react";
import { Alert, Button, Col, Row, Space } from 'antd';
import intl from 'react-intl-universal';
import lodash from 'lodash-es';
import { useState, useEffect } from "react";

import components from "../../../libs/formio";
import Evisit from "../../../libs/Evisit";

const _ = lodash;

Components.setComponents(components);

const getEventAction = (type, component) => {
    if (!component.event) {
        return [];
    }
    var actions = [];
    _.filter(component.event, ['type', type]).forEach(function(event) {
        actions.push(event.action);
    });
    return actions;
}

const FormComponent = ({ currentComponent, onNext, onPrevious, room, data, isMobileWebview }) => {
    const [formIOComponents, setFormIOComponents] = useState({});
    const [formRef, setFormRef] = useState(null);
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState(null);
    const showPrevious = onPrevious != null && !isMobileWebview;

    const onSubmit = (submission) => {
        setAlert(null);
        setLoading(true);
        Evisit.executeActions(
            "submit",
            currentComponent,
            submission,
            data
        ).then(response => {
            onNext(response);
        }).catch(error => {
            setLoading(false);
            setAlert({
                type: "error",
                message: _.get(error, "response.data.message", intl.get("bad_request").d("Bad Request"))
            });
        });
    }

    useEffect(() => {
        const prepareData = () => {
            const components = _.get(currentComponent, "input.form", {});
            if (!currentComponent.data) {
                setFormIOComponents(components);
                return;
            }
            for (var i in components.components) {
                var key = components.components[i]["key"];
                var values = components.components[i]["values"];
                var action = _.find(currentComponent.data, {key: key});
                if (!action) {
                    continue;
                }
                eval(action.action);
                components.components[i]["values"] = values;
            }
            setFormIOComponents(components);
        }
        prepareData();

        setLoading(false);
    }, [currentComponent]);

    return (
        <Space direction="vertical" size="middle" style={{display: 'flex'}}>
            {alert && <Alert message={ alert.message } type={ alert.type } />}
            <Form
                form={formIOComponents}
                onSubmit={(submission) => onSubmit(submission)}
                onCustomEvent={({type, component}) => {
                    var actions = getEventAction(type, currentComponent);
                    for (var i in actions) {
                        eval(actions[i]);
                    }
                }}
                formReady={(formInstance) => {
                    if (currentComponent.value) {
                        formInstance.submission = {
                            data: currentComponent.value
                        };
                    }
                    setFormRef(formInstance);
                }}
                options={{
                    noAlerts: true,
                }}
            />

            <Row gutter={[8, 8]}>
                {showPrevious && (
                    <Col xs={24} sm={24} md={12} className='modal-footer-block-left'>
                        <Button onClick={onPrevious} disabled={loading}>
                            <LeftOutlined style={{verticalAlign: "middle"}} />
                            { _.get(currentComponent, "previous.title", intl.get("back").d("Back")) }
                        </Button> 
                    </Col>
                )}
                <Col xs={24} sm={24} md={showPrevious ? 12 : 24} className='modal-footer-block-right'>
                    <Button
                        type="primary"
                        disabled={!formRef}
                        loading={loading}
                        shape={isMobileWebview ? "round" : "default"}
                        size={isMobileWebview ? "large" : "default"}
                        onClick={() => {
                            formRef.submit();
                        }}
                    >
                        { _.get(currentComponent, "next.title", intl.get("continue").d("Continue")) }
                        <RightOutlined style={{verticalAlign: "middle"}} />
                    </Button>
                </Col>
            </Row>
        </Space>
    );
};

export default FormComponent;